import React from 'react';
import { Button, Typography, Card } from 'components';
import { PrinterOutlined } from '@ant-design/icons';
import { useLabels } from './useLabels';
import { ProgressStepper } from '../components/ProgressStepper';
import styles from './styles.module.scss';

const { Text, Title } = Typography;

export const Labels: React.FC = () => {
  const {
    isLoading,
    packages,
    isDownloadingNote,
    handlePrint,
    handlePrintDeliveryNote,
    handleComplete,
    completedCount,
    totalCount,
  } = useLabels();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <Text>Loading...</Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Progress Stepper */}
      <ProgressStepper currentStep={4} totalSteps={4} completedCount={completedCount} totalCount={totalCount} />

      <div className={styles.content}>
        <div className={styles.header}>
          <Title level={4} className={styles.title}>
            Print Labels
          </Title>
          <Text className={styles.subtitle}>Print shipping labels for all packages</Text>
        </div>

        {/* Packages List */}
        <div className={styles.packagesList}>
          {packages.map((pkg: any, index: number) => (
            <Card key={pkg.id || index} className={styles.packageCard}>
              <div className={styles.packageHeader}>
                <div className={styles.packageInfo}>
                  <Text className={styles.packageNumber}>Package – {pkg.orderNumber}</Text>
                  <Text className={styles.clientName}>Client Name – {pkg.clientName}</Text>
                  {pkg.clientRequestNumber && (
                    <Text className={styles.requestNumber}>Place {pkg.itemsCount} items into this package</Text>
                  )}
                </div>
              </div>

              <div className={styles.packageActions}>
                <Button
                  type="default"
                  size="middle"
                  icon={<PrinterOutlined />}
                  onClick={() => handlePrintDeliveryNote(pkg.id)}
                  loading={isDownloadingNote}
                  block
                  className={styles.actionButton}
                >
                  Print Delivery Note
                </Button>
                <Button
                  type="primary"
                  size="middle"
                  icon={<PrinterOutlined />}
                  onClick={() => handlePrint(pkg.id)}
                  block
                  className={styles.actionButton}
                >
                  Print Label
                </Button>
              </div>
            </Card>
          ))}
        </div>

        {/* Empty State */}
        {packages.length === 0 && (
          <div className={styles.emptyState}>
            <Text className={styles.emptyText}>No packages found</Text>
          </div>
        )}
      </div>

      <div className={styles.bottomActions}>
        <Button type="primary" size="large" onClick={handleComplete} block>
          Complete
        </Button>
      </div>
    </div>
  );
};
